module.exports = __webpack_public_path__ + "static/media/image5.50a954f0.png";